// extracted by mini-css-extract-plugin
export default {"experienceItem":"Experience_experienceItem__XCY-C"};